import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// core-components
import ImageUpload from "../../../components/CustomUpload/ImageUpload";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import Toast from "../../../components/MessageToast";
import { folderDate } from "../../../helpers/formatBlog";
import { uploadImageFile, resetImageStore } from "../../../redux/upload/index";
import { toast } from "react-toastify";

export default (props) => {
  const imageStore = useSelector((store) => store.uploadedImageFile);
  const dispatch = useDispatch();

  const [imageState, setImageState] = useState({
    imageError: "",
    updateComponent: false,
  });

  useEffect(() => {
    dispatch(resetImageStore());
  }, []);

  const handleImageSubmit = async (imageData) => {
    const file = new FormData();
    file.append("files", imageData);
    file.append("destination", props.destination || `images/${folderDate}`);
    await toast.promise(dispatch(uploadImageFile(file)), {
      pending: "Uploading File",
      success: "File uploaded successfully",
      error: imageStore.error.message,
    });

    setImageState({ ...imageState, updateComponent: true });
  };

  if (imageState.updateComponent) {
    if (imageStore.error.message) {
      Toast({
        message: `Can not upload file because: ${imageStore.error.message}`,
        type: "error",
      });
    } else if (imageStore.data.results) {
      props.onFileUploaded(imageStore.data.results[0]);
    }

    setImageState({ ...imageState, updateComponent: false });
  }
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} md={10} sm={10}>
          <ImageUpload
            isSmall={!!props.isSmall}
            isFileUpload={props.isFileUpload}
            defaultImage={props.defaultImg}
            imageSubmit={handleImageSubmit}
            removeUploaded={null}
            imageTypes={
              props.isFileUpload
                ? " application/pdf"
                : "image/jpeg, image/png, image/jpg, image/gif, image/svg, image/bmp, image/ico"
            }
            addButtonProps={{
              color: "primary",
            }}
            changeButtonProps={{
              color: "primary",
            }}
            removeButtonProps={{
              color: "danger",
            }}
            removing={imageState.removing}
            imageError={imageState.imageError}
            isUploading={imageStore.loading}
            uploaded={imageState.uploaded || imageStore.data.path}
          />
        </GridItem>
      </GridContainer>
    </div>
  );
};
